import React, { useState } from 'react';

const StoryConfigModal = ({ onSubmit, onClose, show, results }) => {
  const [config, setConfig] = useState({
    authorStyle: 'Porter Stansberry',
    length: '750',
    slant: 'Neutral',
    notes: ''
  });

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(config);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Story Configuration</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-content">
          <form onSubmit={handleSubmit} className="config-form">
            <div className="form-group">
              <label>Author Style</label>
              <select 
                value={config.authorStyle}
                onChange={(e) => setConfig({...config, authorStyle: e.target.value})}
                className="form-select"
              >
                <option value="Porter Stansberry">Porter Stansberry</option>
                <option value="Wall Street Journal">Wall Street Journal</option>
                <option value="Buzzfeed">Buzzfeed</option>
                <option value="LikeFolio">LikeFolio</option>
              </select>
            </div>

            <div className="form-group">
              <label>Story Length</label>
              <div className="button-group">
                {['300', '500', '750'].map((length) => (
                  <button
                    key={length}
                    type="button"
                    className={`select-button ${config.length === length ? 'active' : ''}`}
                    onClick={() => setConfig({...config, length})}
                  >
                    {length} words
                  </button>
                ))}
              </div>
            </div>

            <div className="form-group">
              <label>Story Slant</label>
              <div className="button-group">
                {[
                  'Bullish',
                  'Cautiously Optimistic',
                  'Neutral',
                  'Concerned',
                  'Bearish'
                ].map((slant) => (
                  <button
                    key={slant}
                    type="button"
                    className={`select-button ${config.slant === slant ? 'active' : ''}`}
                    onClick={() => setConfig({...config, slant})}
                  >
                    {slant}
                  </button>
                ))}
              </div>
            </div>

            <div className="form-group">
              <label>Notes for Writer (Optional)</label>
              <textarea 
                value={config.notes}
                onChange={(e) => setConfig({...config, notes: e.target.value})}
                placeholder="Additional notes or instructions..."
                className="form-textarea"
              />
            </div>

            <div className="form-buttons">
              <button 
                type="button" 
                onClick={onClose} 
                className="cancel-button"
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="submit-button"
              >
                Generate Story
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StoryConfigModal;